export default "__VITE_ASSET__CvcsP6p7__"